import { createSlice } from '@reduxjs/toolkit';

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    userDetails: {},
    passwordForm: 0,
    messageToast: {},
    loader: 0,
    modelDetails: {},
    exportLoader: {
      idList: [],
    },
  },
  reducers: {
    loginUpdate: (state, action) => {
      state.userDetails = action.payload;
    },
    logoutUpdate: (state) => {
      state.userDetails = {};
    },
    showMessageToast: (state, action) => {
      state.messageToast = action.payload;
    },
    enableLoader: (state, action) => {
      state.loader += action.payload ? 1 : -1;
    },
    storeModelDetails: (state, action) => {
      state.modelDetails = {
        ...state.modelDetails,
        ...action.payload,
      };
    },
    enableExportLoader: (state, action) => {
      if (action.payload.loader) {
        state.exportLoader.idList.push(action.payload.id);
      } else {
        state.exportLoader.idList = state.exportLoader.idList.filter(
          (item) => item !== action.payload.id
        );
      }
    },
  },
});

const {
  reducer: loginReducer,
  actions: {
    loginUpdate,
    logoutUpdate,
    showMessageToast,
    enableLoader,
    storeModelDetails,
    enableExportLoader,
  },
} = loginSlice;

export {
  loginReducer,
  loginUpdate,
  logoutUpdate,
  showMessageToast,
  enableLoader,
  storeModelDetails,
  enableExportLoader,
};
